import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  version: "1.1",
  viewBox: "0 0 358 95.82",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m49.1 0.001953a8.379 8.379 0 0 0-8.379 8.379 8.379 8.379 0 0 0 8.379 8.379 8.379 8.379 0 0 0 8.379-8.379 8.379 8.379 0 0 0-8.379-8.379zm124.9 0a8.379 8.379 0 0 0-8.379 8.379 8.379 8.379 0 0 0 8.379 8.379 8.379 8.379 0 0 0 8.379-8.379 8.379 8.379 0 0 0-8.379-8.379zm-174 3.605v72.36h37.16v-16.27h-18.72v-56.09h-18.44zm62.94 0v72.36h16.27v-72.36h-16.27zm21.74 0v72.36h16.27v-72.36h-16.27zm48.71 16.17c-16.92 0-29.29 12.37-29.29 29.29 0 16.49 12.48 28.64 29.4 28.64 16.71 0 29.18-12.37 29.18-28.96 0-16.6-12.48-28.96-29.29-28.96zm79.61 0.1309c-2.393 0.04682-4.836 0.3959-7.287 1.072-15.05 4.155-23.76 19.95-19.46 35.53a28.57 28.57 0 0 0 35.18 20.23c11.08-3.055 18.72-12.48 20.42-25.1l-15.9 4.385a4.929 4.929 0 0 0-0.5273 0.9277c-2.48 4.061-4.625 5.668-8.494 6.736-6.171 1.702-11.84-0.8978-14.19-6.551l39.21-10.82a20.61 20.61 0 0 0-0.7656-4.4c-3.773-13.68-15.27-22.26-28.2-22zm86.09 1.816 18.22 25.17-20.61 29.08h19.42l11.17-16.81 10.85 16.81h19.85l-21.04-29.07 18.22-25.17h-19.2l-8.68 14.21-8.787-14.21h-19.42zm-257.9 0.001953v54.24h16.27v-54.24h-16.27zm125.1 0v53.59c-1e-5 6.184-1.411 8.244-5.75 8.244h-2.17v12.26h4.014c8.249 0 12.48-1.303 15.95-4.883 3.037-3.146 4.229-7.81 4.229-16.16v-53.05h-16.27zm79.07 0v32.44c0 8.678 1.081 12.37 4.881 16.82 3.905 4.446 9.223 6.832 15.84 6.832 7.161 0 11.72-2.387 14.32-7.594v5.752h15.4v-54.24h-16.27v30.27c0 6.726-3.362 10.63-9.219 10.63-6.079 0-8.678-3.147-8.678-10.63v-30.27h-16.27zm-32.53 11.98c4.741-0.1668 8.902 2.177 10.97 6.361l-23.53 6.492c-0.334-6.097 3.136-10.65 9.201-12.33 1.137-0.3141 2.261-0.4869 3.355-0.5254z",
      fill: "#ea3718"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "133.4",
      cy: "48.74",
      r: "15.06",
      fill: "#fff"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "133.4",
      cy: "48.74",
      r: "9.794",
      fill: "#1a1818"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "138.9",
      cy: "43.95",
      r: "3.6",
      fill: "#fff"
    }, null, -1)
  ]))]))
}
export default { render: render }